export default __webpack_public_path__ + "static/media/showreel2021.c298ba7d.mp4";